<template>
	<div
		id="analytics"
		:class="[!isWeb ? 'mobile-analytics' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<iframe
			v-if="isProductionEnvironment()"
			title="Analytics Platform"
			width="100%"
			height="1080px"
			src="https://lookerstudio.google.com/embed/reporting/7fd035ca-620e-41e9-b088-6121c043c093/page/kHa9D"
			style="border: 0"
			allowfullscreen
			sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
		></iframe>
		<iframe
			v-else
			title="Analytics Platform"
			width="100%"
			height="1080px"
			src="https://lookerstudio.google.com/embed/reporting/14f588d2-1b74-4f82-8f0d-6bb26aa0e9f7/page/kHa9D"
			style="border: 0"
			allowfullscreen
			sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
		></iframe>
	</div>
</template>

<script>
export default {
	name: 'Analytics',
	components: {},
	data: () => ({
		windowWidth: window.innerWidth,
	}),
	methods: {
		isProductionEnvironment() {
			return process.env.VUE_APP_ENV === 'prod';
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'Analytics.scss';
</style>
